import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchPosts } from '../services/blogService';
import BlogList from '../components/blog/BlogList';
import BlogPost from '../components/blog/BlogPost';
import BlogNav from '../components/BlogNav';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await fetchPosts();
        if (mounted) setPosts(data);
      } catch (e) {
        console.error('Failed to load posts:', e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {loading ? (
        <div className="min-h-screen flex items-center justify-center">
          <p className="text-gray-400 font-light tracking-widest animate-pulse">INITIALIZING FEED...</p>
        </div>
      ) : (
        <Routes>
          <Route index element={<BlogList posts={posts} />} />
          <Route path="category/:category" element={<BlogList posts={posts} />} />
          <Route path="tag/:tag" element={<BlogList posts={posts} />} />
          <Route path=":id" element={<BlogPost posts={posts} />} />
        </Routes>
      )}
    </div>
  );
};

export default BlogPage;
